<template>
<TrustedContact />
<EmergencyContact />
</template>
<script>
import TrustedContact from '@/components/TrustedContact.vue'
import EmergencyContact from '@/components/EmergencyContact.vue'


export default {
    components: {
TrustedContact,
EmergencyContact


}
  };
  </script>

  
  <style scoped>
  .profile-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
  }
  
  .card {
    background: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    padding: 20px;
    width: 300px;
    box-sizing: border-box;
  }
  
  .card h3 {
    margin-top: 0;
  }


.editable-field {
  margin-bottom: 10px;
}


.editable-field input[type='text'] {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px 10px;
  width: calc(100% - 120px); /* Adjust width as needed */
}


  </style>
  